<template>
  <div class="user-profile-card meeting-card" v-if="name">
    <div class="profile-avatar">
      <k-avatar v-if="avatarUrl" :avatarUrl="avatarUrl"></k-avatar>
      <div v-else class="avatar-circle">
        <i class="fas fa-user"></i>
      </div>
    </div>
    <div class="profile-info">
      <h3 class="profile-name">{{ name }}</h3>
      <div class="profile-role">
        <span class="capitalize-text">{{ role }}</span>
      </div>
      <div class="profile-email">
        <span>{{ email }}</span>
      </div>
    </div>
    <slot></slot>
  </div>
  <div v-else class="user-profile-card meeting-card">
    <div class="profile-avatar">
      <div class="avatar-circle">
        <i class="fas fa-user"></i>
      </div>
    </div>
    <div class="profile-info">
      <span class="profile-role">No user selected</span>
    </div>
  </div>
</template>

<style>
.signed-success {
  color: var(--kate-type-success);
}

.signed-pending {
  color: var(--kate-type-danger);
}
</style>

<style scoped>
.user-profile-card {
  align-items: center;
  display: flex;
  gap: 15px;
  padding: 15px;
  border-radius: 15px;
  background-color: var(--kate-panel-alt);
  border: 1px solid var(--kate-stroke-dark);
  margin: 20px 0;
}

.profile-avatar {
  flex-shrink: 0;
}

.avatar-circle {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-circle i {
  color: var(--kate-mono-1);
}

.capitalize-text {
  text-transform: capitalize;
}

.profile-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.profile-name {
  margin: 0;
  font-size: 1.25em;
  line-height: 1.2;
}

.profile-role,
.profile-email {
  display: flex;
  align-items: center;
  gap: 8px;
}

.profile-role {
  font-style: italic;
  color: var(--kate-type-primary);
}

.signed-success {
  color: var(--kate-type-success);
}

.signed-pending {
  color: var(--kate-type-danger);
}
</style>

<script>

import KAvatar from './k-avatar.vue';

export default {
  components: { KAvatar },
  props: {
    name: {
      type: String,
    },
    email: {
      type: String,
    },
    avatarUrl: {
      type: String,
    },
    role: {
      type: String,
    },
  },
  data() {
    return {
      userInfo: {},
    };
  },
};
</script>
